import slugify from "slugify";

/**
 * Convert string to SEO-friendly slug
 * @param str - input string
 */
export function toSlug(str: string, locale: string = "en"): string {
  let slug = slugify(str, {
    lower: true,
    strict: true,
    locale,
    trim: true,
  });

  if (!slug) {
    slug = str
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^\p{L}\p{N}-]/gu, "");
  }

  return slug;
}
